<template>
  <div class="card">
    <img class="card-left" :src="src" />
    <div class="card-right">
      <div class="card-right-top">{{title}}</div>
      <div class="card-right-bottom" v-html="word"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CCard',
    props: {
      src: {
        type: String,
      },
      title: {
        type: String,
      },
      word: {
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.card {
  width: 100%;
  height: 90px;
  @include flex-between();
  background-color: #fff;

  &-left {
    margin: 0 15px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  &-right {
    margin-right: 20px;
    flex: 1;
    overflow: hidden;

    &-top {
      font-size: 14px;
      color: #333;
      line-height: 25px;
      @include ellipsis();
    }

    &-bottom {
      font-size: 11px;
      color: #666;
      line-height: 15px;
      @include multiline-ellipsis(2);
    }
  }
}
</style>
